import { useBootstrap } from "../query/bootstrap";

// Индикатор связи — порт setDot/boot из app-core.js: wait (проверка) / ok (каталог загружен) / err (нет связи).
export function ConnDot() {
  const q = useBootstrap();
  const state = q.isError ? "err" : q.isSuccess ? "ok" : "wait";
  const txt = state === "ok" ? "Подключено" : state === "err" ? "Нет связи" : "Проверка связи…";
  return (
    <div className="conn" role="status" title={txt} aria-label="статус связи">
      <span className={`api-dot ${state}`} />
      <span className="sr-only">{txt}</span>
    </div>
  );
}
